import { useState } from "react";
import { Link } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { Container, IconButton, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NavDrawer from "./NavDrawer";
import TransLang from "./TransLang"
import logo from './../../assets/logo.png'
import './Nav.css'
import { Pages } from "../../constants";
import i18next from "i18next";

function NavBar() {
    let lng = i18next.language
    const [drawer, setDrawer] = useState(false);
    return (
        <>
            
            <AppBar position="static" elevation={0}
                style={{
                    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                    padding: "10px",
                    position:'fixed',
                    top:0,
                    zIndex: 999, 
                    backgroundColor:'transparent'
                }}>
                <div className={lng === 'ar' ? "bgC" : "bgCEn"}></div>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Box
                            sx={{
                                flexGrow: 1,
                                gap: 5,
                                marginInlineStart: 1,
                                display: { md: "flex", xs: "none" },
                                alignItems: "center",
                                justifyContent: 'space-around'
                            }}>
                            <Link
                                to="/"
                                style={{
                                    textDecoration: "none",
                                    marginInlineStart: 8
                                }}>
                                <img src={logo} height={60} alt="logo" className="nav-logo" />
                            </Link>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-evenly',
                                    alignItems: 'center',
                                    width: '60%'
                                }}>
                                {
                                    Pages?.map((page, i) => <Link
                                        key={i}
                                        to={page.path}
                                        style={{
                                            // fontSize: 14,
                                            textTransform: 'capitalize',
                                            fontWeight: 'bold'
                                        }}
                                        className="link">
                                        {lng === 'ar' ? page.name : page.name_en}
                                    </Link>
                                    )}
                                {/* <a href="tel:+96341556670" style={{ textDecoration: 'none', color: '#FFF', }} >
                                <Typography
                                    style={{
                                        textTransform: 'capitalize',
                                        fontWeight: 'bold'
                                    }}
                                    className="link">
                                    {lng === 'ar' ? 'اتصل بنا' : 'contact us'}
                                </Typography>
                                </a> */}
                                <TransLang />
                            </Box>
                        </Box>
                        <Box sx={{ justifyContent: 'space-between', display: 'flex', gap: { md: '65px', xs: 1 }, width: { md: 'fit-content', xs: '100%' }, alignItems: 'center' }} >
                            <Box
                                sx={{
                                    flexGrow: 0,
                                    display: { md: "none", xs: "flex" },
                                    justifyContent: "space-between",
                                    width: "100%",
                                }}>
                                <Link
                                    to="/"
                                    style={{
                                        textDecoration: "none",
                                        marginInlineStart: 8
                                    }}>
                                    <img src={logo} height={60} alt="logo" className="nav-logo" ></img>
                                </Link>
                                <IconButton onClick={() => setDrawer(true)}>
                                    <MenuIcon sx={{ fontSize: '3rem', color: '#fff' }} />
                                </IconButton>
                            </Box>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
            <NavDrawer drawer={drawer} setDrawer={setDrawer} />
        </>
    );
}
export default NavBar;
